import { ActionTypes } from "store/actions/promotionpopupconfig";

const defaultSessionState = {
  title: "",
  isVisible: false,
};

function promotionPopupConfig(state = defaultSessionState, action) {
  switch (action.type) {
    case ActionTypes.SET_PROMOTION_POPUP_CONFIG:
      return {
        ...state,
        ...action.payload,
      };

    case ActionTypes.SET_PROMOTION_POPUP_VISIBILITY_STATUS:
      return {
        ...state,
        isVisible: action.payload,
      };

    default:
      return state;
  }
}

export default promotionPopupConfig;



// WEBPACK FOOTER //
// ./src/js/store/reducers/promotionpopupconfig.js